import { ReactElement } from 'react';
import { Typography } from 'antd';
import { BaseBlock } from '../../../components/styles/Block';

const { Title } = Typography;

const Header = (): ReactElement => (
  <BaseBlock as='header'>
    <Title level={4}>録音アップロード</Title>
  </BaseBlock>
);

export default Header;
